// extracted by mini-css-extract-plugin
module.exports = {"row":"_404_row_3fIN8","astronaut":"_404_astronaut_2MSVo","float":"_404_float_3Xcm4"};